import React from "react";
import StudentCanRegister from "src/components/promotion/banners/StudentCanRegister";
import Card from "src/components/Card";
import Onboarding from "src/components/dashboard/Onboarding";
import PaymentBalance from "src/components/dashboard/PaymentBalance";
import Layout from "src/components/layout/Layout";
import StudentOnboarding from "src/components/Onboarding/Student/StudentOnboarding";
import Resume from "src/components/resume/Resume";
import ResumeBadges from "src/components/resume/modules/ResumeBadges";
import ResumeExperiencesList from "src/components/resume/modules/ResumeExperiencesList";
import ResumeSkills from "src/components/resume/modules/ResumeSkills";
import useAuth from "src/hooks/selectors/useAuth";
import BankCard from "src/components/cards/BankCard";
import ResumeReviews from "src/components/resume/modules/ResumeReviews";
import ResumeSocialMedia from "src/components/resume/modules/ResumeSocialMedia";
import Link from "src/components/Link";
import { useTranslation } from "react-i18next";

export default function DashboardStudentView() {
	const { t } = useTranslation("dashboard-view", {
		keyPrefix: "student",
	});
	const auth = useAuth();
	const color = auth.primary_color;
	const editable = true;

	return (
		<Layout
			sidebar={
				<>
					<PaymentBalance />
					{/* <ReferralCard /> */}
					<div className="">
						<BankCard />
					</div>
					{/* <div className="">
						<CourseCard />
					</div> */}
				</>
			}
			title={t("title")}
		>
			<StudentCanRegister />
			<Onboarding />
			<Resume.Header
				{...{ editable }}
				backgroundColor={color}
				avatar={auth.avatar}
				name={auth.full_name}
				description={auth?.bio?.bio}
				rating={auth?.rating?.rating}
			/>
			{!auth?.status?.is_onboarded && <StudentOnboarding />}
			<Card
				id="education"
				title={t("cards.education")}
				actions={
					editable && (
						<Link to="/dashboard/resume/experiences#education">
							<small>
								<i className="fas fa-pencil mr-2"></i>
								{t("edit")}
							</small>
						</Link>
					)
				}
			>
				<ResumeExperiencesList
					type="education"
					query={`/resume/${auth.hid}/experiences?type=education`}
					{...{ color }}
				/>
			</Card>

			<Card
				id="jobs"
				title={t("cards.job")}
				actions={
					editable && (
						<Link to="/dashboard/resume/experiences#job">
							<small>
								<i className="fas fa-pencil mr-2"></i>
								{t("edit")}
							</small>
						</Link>
					)
				}
			>
				<ResumeExperiencesList
					type="job"
					query={`/resume/${auth.hid}/experiences?type=job`}
					{...{ color }}
				/>
			</Card>

			<Card
				id="skills"
				title={t("cards.skills")}
				actions={
					editable && (
						<Link to="/dashboard/resume/extra#skills">
							<small>
								<i className="fas fa-pencil mr-2"></i>
								{t("edit")}
							</small>
						</Link>
					)
				}
			>
				<div className="mt-4">
					<ResumeSkills query={`/resume/${auth.hid}/skills`} />
				</div>
			</Card>
			<Card
				id="social-media"
				title={t("cards.socials")}
				actions={
					editable && (
						<Link to="/dashboard/resume/extra#social-media">
							<small>
								<i className="fas fa-pencil mr-2"></i>
								{t("edit")}
							</small>
						</Link>
					)
				}
			>
				<div className="mt-4">
					<ResumeSocialMedia
						query={`/resume/${auth.hid}/social-media`}
					/>
				</div>
			</Card>
			<Card id="badges" title={t("cards.badges")}>
				<div className="mt-4">
					<ResumeBadges query={`/resume/${auth.hid}/badges`} />
				</div>
			</Card>
			<Card id="reviews" title={t("cards.reviews")}>
				<div className="mt-4">
					<ResumeReviews query={`/resume/${auth.hid}/reviews`} />
				</div>
			</Card>
		</Layout>
	);
}
